import React from "react";
import classnames from "classnames";
import { Button } from "reactstrap";

export class ButtonValidation extends React.Component {
  static defaultProps = {
    color: "primary",
    id: null,
    onClick: () => null
  };

  render() {
    const p = this.props;

    return (
      <Button
        id={p.id}
        style={p.style}
        color={!p.is_process ? p.color : "default"}
        onClick={p.onClick}
        disabled={p.disabled || p.is_process}
      >
        {p.is_process && <i className="fa fa-spinner fa-pulse fa-fw ml-2" />}
        {p.children}
      </Button>
    );
  }
}

export function ButtonCancel(props) {
  const { onClick } = props;

  return (
    <Button color="secondary" onClick={onClick}>
      Cancel
    </Button>
  );
}

export function ButtonReject(props) {
  const { is_process, children, onClick, disabled, small } = props;

  if (!is_process) {
    return (
      <Button
        className={classnames("btn-danger", { "btn-sm": small })}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </Button>
    );
  } else {
    return (
      <Button
        className={classnames("btn-default", { "btn-sm": small })}
        disabled={disabled}
      >
        <i className="fa fa-spinner fa-pulse fa-fw"></i>&nbsp;
        {children}
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/component/Button.js